<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
          v-if="user && user.IDStB"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
          {{ title }}
        </div>

        <div v-if="user.alumno_mora" style="width: 100%">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="warning">
              Para solicitar la baja primero debe abonar su deuda
            </v-alert>
          </v-col>
        </div>

        <div v-else-if="user.borrado == '1'" style="width: 100%">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="error">
              La acción no es posible de realizar, Usted se encuentra dado de baja
            </v-alert>
          </v-col>
        </div>
        <!--ESTO SE DEBE CAMBIAR AHORITA LUEGO DE MODIFICAR ESTILOS DENTRO DE V-ROM VA v-if="!user || !user.IDStB"-->
        <div v-else>
          <v-row align="center" v-if="!user || !user.IDStB">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Tipo de documento</label>
              <v-select
                v-model="tipo"
                :items="tipos"
                item-text="text"
                item-value="value"
                label="Selecciona el tipo de documento"
                persistent-hint
                return-object
                single-line
                v-on:change="loadData"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <!-- Título del campo colocado encima del input -->
              <div class="white--text" style="font-size: 14px; font-weight: bold; margin-bottom: 8px;">
                Número de documento 
              </div>

              <!-- Input con bordes redondeados y sin línea de enfoque -->
              <v-text-field
                v-model="documento"
                class="input-classic"
                style="background-color: white; color: black; border-radius: 5px; box-shadow: none;"
                required
                hide-details
                outlined
                placeholder="Escribe el número de documento"
              ></v-text-field>
            </v-col>



          </v-row>

          <v-row align="center">
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              v-if="sede.value != ''"
            >
              <FullCalendar
                class="demo-app-calendar"
                :options="calendarOptions"
                ref="calendar"
                style="width: 100%; height: auto;" 
              >
                <template v-slot:eventContent="arg">
                  <b>{{ arg.timeText }}</b>
                  <i>{{ arg.event.title }}</i>
                </template>
              </FullCalendar>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Reservar turno</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        name="input-7-1"
                        v-model="texto"
                        label="Por favor indique el motivo del turno"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="apartar">
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import Route from "../../config/RouteApi";
import esLocale from "@fullcalendar/core/locales/es";
import moment from "moment";

moment.locale("es");

export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    FullCalendar,
  },

  data: function() {
    return {
      title: "Horario",
      sede: { text: "", value: "" },
      sedes: [],
      tipo: { text: "DNI", value: 1 },
      documento: "",
      tipos: [
        { text: "DNI", value: 1 },
        { text: "PASAPORTE", value: 2 },
      ],
      editable: true,
      dialog: false,
      texto: "",
      turno_id: "",
      calendarOptions: {
        weekends: true,
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "timeGridDay", // O 'timeGridWeek' según lo que desees
        headerToolbar: {
          left: "dayGridMonth,timeGridWeek,timeGridDay",
          center: "title",
          right: "prev,next",
        },
        locale: esLocale,
        eventClick: this.handleEventClick,
        events: "",
        contentHeight: 950,
        // Restringir las horas visibles
        slotMinTime: "07:00:00",  
        slotMaxTime: "24:00:00",  
        
      },
    };
  },
  computed: {
    isSmallScreen() {
      return this.$vuetify.breakpoint.xsOnly; // Detecta si la pantalla es pequeña
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    isSmallScreen(newVal) {
      if (newVal) {
        this.calendarOptions.initialView = "timeGridDay"; // Solo se muestra la vista de "día"
      } else {
        this.calendarOptions.initialView = "timeGridWeek"; // Vista por defecto o la que desees para pantallas grandes
      }
    },
  },
  mounted() {

    if (this.isSmallScreen) {
      this.calendarOptions.initialView = "timeGridDay";
    } else {
      this.calendarOptions.initialView = "timeGridWeek"; // Ajusta esto según lo que quieras para pantallas grandes
    }
    this.$API
      .get({
        url: "sedes",
        data: {},
      })
      .then((res) => {
        this.sedes = res;
        this.sede.value = this.sedes[this.sedes.length - 1].value;
        this.loadData();
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    handleEventClick(clickInfo) {
      let datos = clickInfo.event.extendedProps;
      
      if(datos.link !== ''){
        window.open(datos.link, '_blank');
      }
      
      console.log(datos);
    },

    async loadData() {
      this.calendarOptions.events = Route + `horario/${this.user.IDStB}`;
    },
    async apartar() {
      //this.dialog = false;
      if (this.texto.trim() == "") {
        alert("Debe colocar un motivo para el turno");
        return;
      }

      let dataSend = {
        text: this.texto,
        turno_id: this.turno_id,
        documento: this.documento,
        tipoDocumento: this.tipo.value,
        alumno_id: this.user.IDStB,
      };

      let url = "turno-presencial/inscribirTurno";

      await this.$API
        .post({
          url: url,
          data: dataSend,
        })
        .then(() => {
          this.texto = "";
          this.turno_id = 0;
          this.dialog = false;

          let calendarApi = this.$refs.calendar.getApi();
          calendarApi.refetchEvents();
        });
    },
  },
};
</script>
<style scoped>
   .v-application .primary--text {
      color: white !important;
      caret-color: #125ea5 !important;
  }

  /* Títulos responsivos */
  .text-xs-h4 {
    font-size: 1.2rem;
  }
  .text-sm-h4 {
    font-size: 1.4rem;
  }
  .text-md-h4 {
    font-size: 1.6rem;
  }
  .text-lg-h4 {
    font-size: 1.8rem;
  }
  .text-xl-h4 {
    font-size: 2rem;
  }

  ::v-deep .fc .fc-toolbar-title {
    font-size: 1.75em;
    margin: 0;
    color: white;
  }

  ::v-deep .fc .fc-timegrid-axis-cushion {
    max-width: 60px;
    flex-shrink: 0;
    color: white !important;
  }

  ::v-deep .fc .fc-timegrid-slot-label {
    vertical-align: middle;
    color: white;
  }

  ::v-deep .fc .fc-col-header-cell-cushion {
    display: inline-block;
    padding: 2px 4px;
    color: white !important;
  }

  ::v-deep .fc .fc-daygrid-day-number {
    position: relative;
    z-index: 4;
    padding: 4px;
    color: white !important;
  }

  ::v-deep .fc .fc-daygrid-day-frame {
    position: relative;
    min-height: 100%;
    background-color: #125ea500 !important;
  }

  /* Ajustar el calendario para pantallas pequeñas */
  @media (max-width: 600px) {

    .v-application .primary--text {
      color: white !important;
      caret-color: #125ea5 !important;
      text-align: center;
    }
    ::v-deep .fc-dayGridMonth-button,
    ::v-deep .fc-timeGridWeek-button {
      display: none !important; /* Oculta los botones de 'Mes' y 'Semana' */
    }
        /* Mover los controles (flechas y título) a la parte inferior */
    ::v-deep .fc .fc-toolbar {
      flex-direction: column; /* Esto pone los controles en una columna */
      justify-content: center;
      align-items: center;
      margin-top: 10px;
    }

    ::v-deep .fc .fc-toolbar-title {
      font-size: 1.4em;
      margin-bottom: 10px;
      margin-top:10px;
    }

    ::v-deep .fc .fc-button {
      font-size: 1.2rem; /* Reducir el tamaño de las flechas */
    }

    ::v-deep .fc .fc-daygrid-day-frame {
      min-height: 75px; /* Aumentar la altura de las celdas en dispositivos pequeños */
    }

    /* Aumentar la altura del calendario */
    .demo-app-calendar {
      height: 100vh !important; /* Hacer que el calendario ocupe más espacio verticalmente */
    }

    /* Asegurar que los días y eventos estén centrados y no se solapen */
    ::v-deep .fc .fc-daygrid-day-number {
      padding: 6px;
      font-size: 1rem; /* Hacer el texto más grande para mayor legibilidad */
    }

    ::v-deep .fc .fc-timegrid-slot-label {
      font-size: 1.1rem;
    }

    /* Ajustar los botones y campos de entrada */
    .v-btn {
      font-size: 0.9rem;
    }

    .v-text-field, .v-select {
      font-size: 0.8rem;
    }
  }

  ::v-deep .theme--light.v-card {
    background-color: #FFFFFF !important;
    color: white !important;
  }

  ::v-deep .v-icon__svg {
    height: 24px;
    width: 24px;
    fill: currentColor;
    color: white !important;
  }

  ::v-deep .theme--light.v-select .v-select__selections {
    color: white !important;
  }
  ::v-deep .v-text-field input {
    flex: 1 1 auto;
    line-height: 20px;
    padding: 8px 0 8px;
    max-width: 100%;
    min-width: 0px;
    width: 50%;
    margin-top: -25px;
  }
  
</style>
